import { render } from "./financeStatisticsGoods.vue?vue&type=template&id=5e27f250"
import script from "./financeStatisticsGoods.vue?vue&type=script&lang=js"
export * from "./financeStatisticsGoods.vue?vue&type=script&lang=js"

import "./financeStatisticsGoods.vue?vue&type=style&index=0&id=5e27f250&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__